/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-api-client";
import type { CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, CfrTranscodingGetCfrTranscodingJobStatusPathParams } from "../models/CfrTranscodingGetCfrTranscodingJobStatus";

export function getCfrTranscodingGetCfrTranscodingJobStatusUrl(fragmentId: CfrTranscodingGetCfrTranscodingJobStatusPathParams["fragmentId"]) {
  const res = { method: 'GET', url: `/cfr-transcoding/${fragmentId}/status` as const }  
  return res
}

/**
 * @summary Get CFR transcoding job status for a fragment
 * {@link /cfr-transcoding/:fragmentId/status}
 */
export async function cfrTranscodingGetCfrTranscodingJobStatus(fragmentId: CfrTranscodingGetCfrTranscodingJobStatusPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<CfrTranscodingGetCfrTranscodingJobStatusQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getCfrTranscodingGetCfrTranscodingJobStatusUrl(fragmentId).url.toString(), ... requestConfig })  
  return res.data
}